import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl';
import './Header.css'
import { FiMenu, FiX } from "react-icons/fi";

export type HeaderProps = {};

const Header: React.FC<HeaderProps> = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <div className='h-[110px] bg-main w-full flex flex-row justify-center items-center relative z-50'>
      <div className="w-full max-w-7xl py-2 px-4 flex flex-row items-center justify-between text-white ">
        <div id="logo" className="h-full w-32 flex justify-center">
          <a href="/">
            <img className="w-28" src="/icons/mcb.svg" alt='MCB - Mexico Certifying Body' />
          </a>
        </div>
        <div id="navigation" className={`w-full gap-4 px-4 md:hidden mobile-menu-${menuOpen ? 'open' : 'closed'}`}>
          <div className="nav-item">
            <a href={'/'}>
              <FormattedMessage
                id={'start'}
                defaultMessage={'Start'}
              />
            </a>
          </div>
          <div className="nav-item">
            <a href={'/about-us'}>
              <FormattedMessage
                id={'about_us'}
                defaultMessage={'About Us?'}
              />
            </a>
            <div className="nav-drawer">
              <a href={'/about-us'}>
                <FormattedMessage
                  id={'about-us2'}
                  defaultMessage={'About Us'}
                />
              </a>
              <a href={'/accreditation'}>
                <FormattedMessage
                  id={'accreditation'}
                  defaultMessage={'Accreditation'}
                />
              </a>
            </div>
          </div>
          <div className="nav-item">
            <a href={'/certification-services/process-of-certification'}>
              <FormattedMessage
                id={'cert_services'}
                defaultMessage={'Certification Services'}
              />
            </a>
            <div className="nav-drawer">
              <a href={'/certification-services/electronics'}>
                <FormattedMessage
                  id={'electronics'}
                  defaultMessage={'Electronics'}
                />
              </a>
              <a href={'/certification-services/telecommunications'}>
                <FormattedMessage
                  id={'telecommunications'}
                  defaultMessage={'Telecommunications'}
                />
              </a>
              <a href={'/certification-services/energy-efficiency'}>
                <FormattedMessage
                  id={'energy-efficiency'}
                  defaultMessage={'Energy Efficiency'}
                />
              </a>
              <a href={'/certification-services/process-of-certification'}>
                <FormattedMessage
                  id={'proc-cert'}
                  defaultMessage={'PROCESS OF CERTIFICATION'}
                />
              </a>
            </div>
          </div>
          <div className="nav-item">
            <a href={'/general-info/public-info'}>
              <FormattedMessage
                id={'general_info'}
                defaultMessage={'General Information'}
              />
            </a>
            <div className="nav-drawer">
              <a href={'/general-info/public-info'}>
                <FormattedMessage
                  id={'public-info'}
                  defaultMessage={'Public Information'}
                />
              </a>
              <a href={'/general-info/faq'}>
                <FormattedMessage
                  id={'faq'}
                  defaultMessage={'Frequently Asked Questions'}
                />
              </a>
              <a href={'/general-info/webinars'}>
                <FormattedMessage
                  id={'webinars'}
                  defaultMessage={'Webinars'}
                />
              </a>
            </div>
          </div>
          <div className="nav-item">
            <a href={'/news'}>
              <FormattedMessage
                id={'regulatory-updates'}
                defaultMessage={'Regulatory Updates'}
              />
            </a>
            <div className="nav-drawer">
              <a href={'/news/official-nom'}>
                <FormattedMessage
                  id={'official-nom'}
                  defaultMessage={'Official NOM'}
                />
              </a>
              <a href={'/news/industry-updates'}>
                <FormattedMessage
                  id={'industry-updates'}
                  defaultMessage={'Industry Updates'}
                />
              </a>
              <a href={'/news/mcb-updates'}>
                <FormattedMessage
                  id={'mcb-updates'}
                  defaultMessage={'MCB Updates'}
                />
              </a>
            </div>
          </div>
          <div className="nav-item">
            <a href={'/contact/complaints-appeals'}>
              <FormattedMessage
                id={'contact'}
                defaultMessage={'Contact Us'}
              />
            </a>
            <div className="nav-drawer">
              <a href={'/contact/complaints-appeals'}>
                <FormattedMessage
                  id={'complaints-appeals'}
                  defaultMessage={'Complaints and Appeals'}
                />
              </a>
              <a href={'/contact/meet-us'}>
                <FormattedMessage
                  id={'meet-us'}
                  defaultMessage={'Come and meet us'}
                />
              </a>
            </div>
          </div>
        </div>
        <div id="login" className="hidden lg:block">
	  <a href="/dashboardfe/auth/login">
            <button className="h-[50px] w-[150px] bg-secondary rounded-md">
              <FormattedMessage
                id={'login'}
                defaultMessage={'Login'}
              />
            </button>
          </a>
        </div>
        <div id="mobile-menu" className="block lg:hidden">
          <div className="" onClick={() => {setMenuOpen(!menuOpen)}}>
            {menuOpen ? (
              <FiX size={48} className="text-white"/>
            ) : (
              <FiMenu size={48} className="text-white"/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
